import React from "react";
import { resolveValue, toast, Toaster } from "react-hot-toast";

const Notification = () => {
  return (
    <Toaster
      containerClassName={"flash-message-wrapper"}
      position={"bottom-right"}
      toastOptions={{
        duration: 10000,
        success: {
          duration: 10000,
          theme: {
            primary: "flash-success",
          },
        },
        error: {
          duration: 10000,
          theme: {
            primary: "flash-error",
          },
        },
      }}
    >
      {(t) => (
        <div className={`flash-message ${t.theme.primary}`}>
          <a
            className="btn-close"
            onClick={() => {
              toast.dismiss(t.id);
            }}
          >
            &times;
          </a>
          {t.message[0]?.title && <h6>{t.message[0].title}</h6>}
          <p style={{ marginRight: "0.5%" }}>
            {" "}
            {resolveValue(t.message[0]?.body || t.message, t)}
          </p>
        </div>
      )}
    </Toaster>
  );
};

export default Notification;
